/**
 * 問卷（訊息類型）題目與作答的型別定義
 * 對應後端 POST /api/questionsetting、POST /api/questionanswer
 */

/** 題型：txt 文字／num 數字／opt 單選／mopt 多選 */
export type QuestionType = 'txt' | 'num' | 'opt' | 'mopt';

/** App 端目前支援的題型清單；收到不在清單內的題型時要明顯提示「需更新 App」，不可退回單選 */
export const SUPPORTED_QUESTION_TYPES: QuestionType[] = ['txt', 'num', 'opt', 'mopt'];

/** questionsetting sel 回傳的單一題目 */
export interface QuestionSettingInfo {
  q_id: number;
  message_type_id: number;
  q_desc: string;
  q_type: QuestionType | string;
  /** 選項清單，以 | 分隔（opt／mopt 用） */
  q_ans_list: string;
  /**
   * num：數值下限
   * mopt：最少可選幾項，0 = 不限
   */
  q_num_min: number | string;
  /**
   * num：數值上限
   * mopt：最多可選幾項，0 = 不限
   */
  q_num_max: number | string;
  q_require: 'Y' | 'N' | string;
  q_img_url: string;
  q_sort: number;

  // ---- 以下為 App 端整理後附加的欄位，非 API 原始欄位 ----
  /** q_ans_list 拆解後的選項陣列（opt／mopt） */
  q_ans_list_arry?: string[];
  /** mopt 有效下限（q_require=Y 且未設下限時等同 1） */
  mopt_min?: number;
  /** mopt 有效上限（0 = 不限） */
  mopt_max?: number;
  /** 是否為本版 App 不支援的題型 */
  unsupported?: boolean;
}

/** questionanswer upser 送出的單題答案；mopt 的 q_value 為選項陣列 */
export interface QuestionAnswerItem {
  q_id: number;
  q_desc?: string;
  q_value: string | string[];
}

/** questionanswer sel 讀回的單筆作答（後端可能回 q_value 或正規化後的 q_data_value） */
export interface QuestionAnswerInfo {
  q_id: number;
  q_desc?: string;
  q_value?: string | string[];
  q_data_value?: string | string[];
}
